import React from 'react'

import { Grid } from '@material-ui/core'

import { useLiterals } from '~/components/Literals'

import ProductCard from './ProductCard'

export default function ProductsGrid({ products, handleProductClick }) {
  const { getLiteral } = useLiterals()

  return (
    <Grid container spacing={4}>
      {products.map((product) => {
        return (
          <Grid
            item
            key={product.gtin}
            style={{
              display: 'flex',
              width: 380,
            }}
          >
            <ProductCard product={product} productClick={() => handleProductClick(product)} getLiteral={getLiteral} />
          </Grid>
        )
      })}
    </Grid>
  )
}
